
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$provider.js';
